import Vue from 'vue'
import vueCropper from 'vue-cropper'
Vue.use(vueCropper)
